import {ContextMenu as DevContextMenu} from 'devextreme-react/context-menu';


export default function ContextMenu({ items, target }) {
    const onContextMenuItemClick = (e) => {
        e.itemData.onItemClick?.(e);
    };
    return (
        <DevContextMenu
            onItemClick={onContextMenuItemClick}
            items={items}
            target={target} />
    )
}